import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'template-edit-header',
	template: require('./template-edit-header.component.html'),
	styles: [require('./template-edit-header.component.scss')]
})
export class TemplateEditHeaderComponent {
	@Input() disableButtons: boolean;
	@Output() onGoBack: EventEmitter<void> = new EventEmitter<void>();
	@Output() onSave: EventEmitter<void> = new EventEmitter<void>();
	hideHeaderBlock;
	hideBanner;

	ngOnInit(): void {
		this.hideHeaderBlock = document.querySelector('#header-fantom-block');
		this.hideBanner = document.querySelector('#banner');
		this.hideHeaderBlock.classList.add('is-show-header');
		this.hideBanner && this.hideBanner.classList.add('is-show-header');
	}

	ngOnDestroy(): void {
		this.hideHeaderBlock.classList.remove('is-show-header');
		this.hideBanner && this.hideBanner.classList.remove('is-show-header');
	}

	goBackAction(): void {
		this.onGoBack.emit();
	}

	saveAction(): void {
		this.onSave.emit();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/settings/common/template-edit-header/template-edit-header.component.ts